import { Card, CardContent } from "../ui/card";
import { IoChevronForwardOutline } from "react-icons/io5";

export type SettingOption = {
  id: string;
  icon: React.ReactNode;
  title: string;
  description?: string;
  onClick?: () => void;
};

interface SettingsMenuProps {
  title?: string;
  options?: SettingOption[];
  onOptionClick?: (id: string) => void;
}

const defaultOptions: SettingOption[] = [
  // {
  //   id: "personal-data",
  //   icon: null,
  //   title: "Dados pessoais",
  //   description: "Gerencie suas informações pessoais",
  // },
  {
    id: "terms-and-privacy",
    icon: null,
    title: "Termos de Uso e Política de Privacidade",
    description: "Leia os termos e entenda como seus dados são protegidos",
  },
  {
    id: "help-support",
    icon: null,
    title: "Ajuda e suporte",
    description: "Obtenha ajuda e entre em contato",
  },
];

export const SettingsMenu = ({
  title = "Configurações",
  options = defaultOptions,
  onOptionClick,
}: SettingsMenuProps) => {
  const handleClick = (id: string, customOnClick?: () => void) => {
    if (customOnClick) {
      customOnClick();
    } else {
      onOptionClick?.(id);
    }
  };

  return (
    <div className="mt-5">
      <h3 className="mb-2 font-semibold text-[17px]">{title}</h3>
      <Card>
        <CardContent className="divide-y bg-white rounded-lg divide-gray-200 p-0">
          {options.map((option) => (
            <SettingsMenuItem
              key={option.id}
              {...option}
              onClick={() => handleClick(option.id, option.onClick)}
            />
          ))}
        </CardContent>
      </Card>
    </div>
  );
};

interface SettingsMenuItemProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  onClick?: () => void;
}

const SettingsMenuItem = ({
  icon,
  title,
  description,
  onClick,
}: SettingsMenuItemProps) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors duration-200 text-left cursor-pointer"
    >
      <div className="flex items-center gap-3">
        {icon && <div className="flex-shrink-0">{icon}</div>}
        <div>
          <p className="font-medium text-gray-900">{title}</p>
          {description && (
            <p className="text-sm text-gray-500">{description}</p>
          )}
        </div>
      </div>
      <IoChevronForwardOutline className="h-5 w-5 text-gray-400 flex-shrink-0" />
    </button>
  );
};
